import type { CardId } from '../../content/cards';

export const CARD_HAND_LIMIT = 1;
export const CARD_REPLENISH_CONTACTS = 6;
export const STONE_LIMIT = 99;

export type HandCard = Readonly<{
  instanceId: string;
  cardId: CardId;
  slot: number;
}>;

export type CardStockState = Readonly<{
  stones: number;
  hand: readonly HandCard[];
  normalContactsTowardReplacement: number;
  nextInstanceSequence: number;
}>;

const INITIAL_HAND: readonly CardId[] = ['destroy'];

export function createCardStock(): CardStockState {
  return {
    stones: 0,
    hand: INITIAL_HAND.map((cardId, index) => ({ instanceId: `card-${index + 1}`, cardId, slot: index })),
    normalContactsTowardReplacement: 0,
    nextInstanceSequence: INITIAL_HAND.length + 1,
  };
}

export function awardMergeStones(state: CardStockState, mergeCount = 1): CardStockState {
  const stones = Math.min(STONE_LIMIT, state.stones + Math.max(0, mergeCount));
  return stones === state.stones ? state : { ...state, stones };
}

export function recordNormalContact(
  state: CardStockState,
  drawCardId: () => CardId,
): CardStockState {
  const progress = state.normalContactsTowardReplacement + 1;
  if (progress < CARD_REPLENISH_CONTACTS) return { ...state, normalContactsTowardReplacement: progress };
  return replaceHandCard(state, drawCardId);
}

function replaceHandCard(state: CardStockState, drawCardId: () => CardId): CardStockState {
  return {
    ...state,
    hand: [{ instanceId: `card-${state.nextInstanceSequence}`, cardId: drawCardId(), slot: 0 }],
    normalContactsTowardReplacement: 0,
    nextInstanceSequence: state.nextInstanceSequence + 1,
  };
}

export function consumeHandCard(state: CardStockState, instanceId: string, cost: number, drawCardId: () => CardId): CardStockState {
  const index = state.hand.findIndex((card) => card.instanceId === instanceId);
  if (index < 0 || state.stones < cost) return state;
  return replaceHandCard({ ...state, stones: state.stones - cost }, drawCardId);
}
